import { render, staticRenderFns } from "./dataTableActions.vue?vue&type=template&id=b56e89e8&scoped=true&"
import script from "./dataTableActions.vue?vue&type=script&lang=js&"
export * from "./dataTableActions.vue?vue&type=script&lang=js&"
import style0 from "./dataTableActions.vue?vue&type=style&index=0&id=b56e89e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b56e89e8",
  null
  
)

export default component.exports